import { Box, Flex, FlexItem } from '@volue/wave-react';
import React from 'react';

import { useActions, useAppState } from '@/overmind';

import {
  anyGridElementRequiresAttention,
  countAllGridElementsRequiringAttention,
  countAllIssuesRequiringAttention
} from '../../overmind/calculation/evaluation/attentionRequired';
import { getGridElementsWithIssuesRequiringAttentionText } from '../../overmind/calculation/evaluation/attentionRequiredMessages';
import type { AllTacticResultsProps } from './Calculation';
import { CalculationsSummary } from './CalculationSummary';
import { GridElementsTree } from './GridElementsTree';
import { InlineNotification } from './InlineNotification';

export function AllTacticResults(props: AllTacticResultsProps) {
  const gridElementsDetails =
    useAppState().calculation.gridElementsDetailsByCalculationType;
  const gridElementsSummary =
    useAppState().calculation.gridElementsAttentionSummary;
  const handleGridElementSelected =
    useActions().calculation.handleGridElementSelected;
  const attentionStatuses =
    useAppState().calculation.gridElementsAttentionStatuses;
  const isEvaluated =
    gridElementsDetails.type === 'EVALUATED' &&
    attentionStatuses.type === 'AVAILABLE';

  if (props.calculationTacticResult?.status === 'Failed') return null;

  return (
    <Flex className="w100 mBxl" flow={'column'}>
      <FlexItem flex={'auto'} css={{ marginTop: '$spacingL' }}>
        {isEvaluated &&
          anyGridElementRequiresAttention(
            attentionStatuses.byCalculationType
          ) && (
            <InlineNotification
              type="WARNING"
              content={getGridElementsWithIssuesRequiringAttentionText(
                countAllGridElementsRequiringAttention(
                  attentionStatuses.byCalculationType
                ),
                countAllIssuesRequiringAttention(
                  attentionStatuses.byCalculationType
                )
              )}
            />
          )}
      </FlexItem>
      <FlexItem flex="auto">
        {props.calculationTacticResult && (
          <CalculationsSummary
            calculationTacticResult={props.calculationTacticResult}
            loadFlowSummary={props.loadFlowSummary}
            shortCircuitSummary={props.shortCircuitSummary}
          />
        )}
      </FlexItem>
      <FlexItem flex="auto">
        <Flex flow={'column'} className="mHxl">
          <Box
            css={{
              color: '$colorAccent70',
              fontWeight: 'bolder',
              fontSize: 'larger'
            }}
          >
            {'Elements that require attention'}
          </Box>
          {gridElementsSummary.type === 'GRID_ELEMENTS_SUMMARY_AVAILABLE' && (
            <FlexItem flex="auto">
              {props.calculationTacticResult && (
                <GridElementsTree
                  sections={gridElementsSummary.summary}
                  onGridElementClicked={handleGridElementSelected}
                />
              )}
            </FlexItem>
          )}
        </Flex>
      </FlexItem>
    </Flex>
  );
}
